import { useEffect } from 'react';
import { useLayoutScreenContext } from '../LayoutScreen/LayoutScreenContext.js';

var useCollapseLayoutSidebar = function () {
    var sidebar = useLayoutScreenContext().sidebar;
    var setLayout = sidebar.collapseState.setLayout;
    useEffect(function () {
        setLayout(true);
        return function () { return setLayout(null); };
    }, []);
};

export { useCollapseLayoutSidebar };
//# sourceMappingURL=useCollapseLayoutSidebar.js.map
